import { DefaultLogic } from '../default';

export class MealDeliveryLogic extends DefaultLogic {
    getColors() {
        return {
            primary: '#FF6600',
            secondary: '#17C37D',
            background: '#FFFFFF',
            accent: '#439DFF',
        };
    }
}
